import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


export function InactivityModal({ isOpen, messageTitle, action, msgSecundary, msgPrimary, title, onHide }) {

    const handleClick = (type, action) => {

        switch (type) {
            case 'primary':
                action();
                break;
            case 'secondary':
                break;
            default:
                break;
        }
    }

    return (
        <div>

            <Dialog
                disableEscapeKeyDown={true}
                open={isOpen}
                onClose={onHide}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={'xs'}
                fullWidth={true}
            >
                <DialogTitle style={{ fontWeight: 'bolder', fontFamily: 'GT Walsheim Pro' }} id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{ color: 'grey', fontFamily: 'GT Walsheim Pro'}} id="alert-dialog-description">
                        {messageTitle}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button style={{fontWeight: 'bold', fontFamily: 'GT Walsheim Pro'}} type='button' onClick={() => handleClick('secondary', action)}>
                        {msgSecundary}
                    </Button>
                    <Button style={{backgroundColor:'rgb(126 2 252)', fontWeight:'bold', fontFamily: 'GT Walsheim Pro', color:'white'}} variant="contained" type='button' onClick={() => handleClick('primary', action)}>
                        {msgPrimary}
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    );
}